import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Custom permissions controlling visibility of sidebar nav items.
 *
 * Ported from the legacy app's Root.tsx. Each gates a specific menu entry:
 * - devtoolsReadPermission: DevTools item in the Settings group
 * - techRadarReadPermission: Tech Radar item
 * - createMenuReadPermission: Create... item
 */
export const devtoolsReadPermission = createPermission({
  name: 'devtools.read',
  attributes: { action: 'read' },
});

export const techRadarReadPermission = createPermission({
  name: 'tech-radar.read',
  attributes: { action: 'read' },
});

export const createMenuReadPermission = createPermission({
  name: 'create-menu.read',
  attributes: { action: 'read' },
});
